(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const slideshows = document.querySelectorAll('.product-slideshow');
    
    slideshows.forEach(slideshow => {
      const slides = slideshow.querySelectorAll('.product-slideshow__slide');
      const dots = slideshow.querySelectorAll('.product-slideshow__dot');
      const prevArrow = slideshow.querySelector('.product-slideshow__arrow--prev');
      const nextArrow = slideshow.querySelector('.product-slideshow__arrow--next');
      let currentSlide = 0;
      let slideInterval = null;
      let userInteractionTimeout = null;
      
      if (slides.length <= 1) return;
      
      function showSlide(index) {
        slides.forEach(slide => slide.classList.remove('product-slideshow__slide--active'));
        dots.forEach(dot => dot.classList.remove('product-slideshow__dot--active'));
        
        slides[index].classList.add('product-slideshow__slide--active');
        if (dots[index]) {
          dots[index].classList.add('product-slideshow__dot--active');
        }
      }
      
      function nextSlide() {
        currentSlide = (currentSlide + 1) % slides.length;
        showSlide(currentSlide);
      }
      
      function prevSlide() {
        currentSlide = (currentSlide - 1 + slides.length) % slides.length;
        showSlide(currentSlide);
      }
      
      function startSlideshow() {
        if (!userInteractionTimeout) {
          slideInterval = setInterval(nextSlide, 1000);
        }
      }
      
      function stopSlideshow() {
        if (slideInterval) {
          clearInterval(slideInterval);
          slideInterval = null;
        }
      }
      
      function handleUserInteraction() {
        stopSlideshow();
        
        if (userInteractionTimeout) {
          clearTimeout(userInteractionTimeout);
        }
        
        userInteractionTimeout = setTimeout(() => {
          userInteractionTimeout = null;
          if (slideshow.matches(':hover')) {
            startSlideshow();
          }
        }, 3000);
      }
      
      // Arrow click handlers
      if (nextArrow) {
        nextArrow.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          nextSlide();
          handleUserInteraction();
        });
      }
      
      if (prevArrow) {
        prevArrow.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          prevSlide();
          handleUserInteraction();
        });
      }
      
      // Keyboard navigation
      slideshow.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault();
          if (e.key === 'ArrowLeft') {
            prevSlide();
          } else {
            nextSlide();
          }
          handleUserInteraction();
        }
      });
      
      // Make slideshow focusable for keyboard navigation
      slideshow.setAttribute('tabindex', '0');
      slideshow.setAttribute('role', 'region');
      slideshow.setAttribute('aria-label', 'Product image gallery');
      
      // Hover events for auto-play
      slideshow.addEventListener('mouseenter', startSlideshow);
      slideshow.addEventListener('mouseleave', () => {
        stopSlideshow();
        currentSlide = 0;
        showSlide(0);
      });
    });
    
    function initializeWishlistButtons() {
      // Initialize wishlist on first load if not exists
      if (typeof window.WishlistManager === 'undefined') {
        window.WishlistManager = {
          key: 'marie_laporte_wishlist',
          
          get() {
            try {
              const wishlist = localStorage.getItem(this.key);
              return wishlist ? JSON.parse(wishlist) : [];
            } catch (error) {
              console.error('Error getting wishlist:', error);
              return [];
            }
          },
          
          save(wishlist) {
            try {
              localStorage.setItem(this.key, JSON.stringify(wishlist));
              this.updateWishlistIcons();

              // Dispatch event to update wishlist count in header
              window.dispatchEvent(new CustomEvent('wishlistUpdated', {
                detail: { count: wishlist.length }
              }));

              return true;
            } catch (error) {
              console.error('Error saving wishlist:', error);
              return false;
            }
          },
          
          add(product) {
            const wishlist = this.get();
            const exists = wishlist.find(item => item.id === product.id);
            if (!exists) {
              wishlist.push({
                id: product.id,
                title: product.title,
                url: product.url,
                price: product.price,
                image: product.image,
                handle: product.handle,
                addedAt: new Date().toISOString()
              });
              this.save(wishlist);
            }
            return !exists;
          },
          
          remove(productId) {
            const wishlist = this.get();
            const newWishlist = wishlist.filter(item => item.id !== productId);
            this.save(newWishlist);
            return wishlist.length !== newWishlist.length;
          },
          
          contains(productId) {
            return this.get().some(item => item.id === productId);
          },
          
          count() {
            return this.get().length;
          },
          
          clear() {
            localStorage.removeItem(this.key);
            this.updateWishlistIcons();
          },

          updateWishlistIcons() {
            const wishlistButtons = document.querySelectorAll('.product-card__wishlist');
            wishlistButtons.forEach(button => {
              const productId = parseInt(button.dataset.productId || button.closest('[data-product-id]')?.dataset.productId);
              if (productId) {
                this.updateWishlistIcon(button, this.contains(productId));
              }
            });
          },

          updateWishlistIcon(button, isInWishlist) {
            const svg = button.querySelector('svg path');
            if (svg) {
              if (isInWishlist) {
                svg.setAttribute('fill', 'currentColor');
                button.classList.add('product-card__wishlist--active');
                button.setAttribute('aria-label', 'Remove from wishlist');
              } else {
                svg.setAttribute('fill', 'none');
                button.classList.remove('product-card__wishlist--active');
                button.setAttribute('aria-label', 'Add to wishlist');
              }
            }
          }
        };
      }

      // Add click handlers to wishlist buttons
      const wishlistButtons = document.querySelectorAll('.product-card__wishlist');
      wishlistButtons.forEach(button => {
        // Remove existing event listeners to avoid duplicates
        button.replaceWith(button.cloneNode(true));
      });
      
      // Re-select buttons after cloning
      document.querySelectorAll('.product-card__wishlist').forEach(button => {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const productId = parseInt(this.dataset.productId || this.closest('[data-product-id]')?.dataset.productId);
          if (!productId) return;
          
          const productCard = this.closest('.product-card');
          const productLink = this.closest('.product-card-link');
          
          if (productCard && productLink) {
            // Get product data from the DOM
            const titleEl = productCard.querySelector('.text-product-box');
            const priceEl = productCard.querySelector('.product-card__price');
            const imageEl = productCard.querySelector('.product-slideshow__slide img');
            
            const product = {
              id: productId,
              title: titleEl ? titleEl.textContent.trim() : '',
              url: productLink.getAttribute('href') || '',
              price: priceEl ? priceEl.textContent.trim() : '',
              image: imageEl ? imageEl.getAttribute('src') : '',
              handle: productLink.getAttribute('href') ? productLink.getAttribute('href').split('/').pop() : ''
            };
            
            const isInWishlist = window.WishlistManager.contains(productId);
            
            if (isInWishlist) {
              window.WishlistManager.remove(productId);
              this.setAttribute('aria-label', 'Add to wishlist');
            } else {
              window.WishlistManager.add(product);
              this.setAttribute('aria-label', 'Remove from wishlist');
            }
            
            // Update icon immediately
            window.WishlistManager.updateWishlistIcon(this, !isInWishlist);
          }
        });
      });
      
      // Update all icons on initialization
      if (window.WishlistManager) {
        window.WishlistManager.updateWishlistIcons();
      }
    }

    // Initialize wishlist functionality after function definition
    initializeWishlistButtons();

    // Listen for page show event (including back/forward cache restoration)
    window.addEventListener('pageshow', function(event) {
      // If the page was restored from back/forward cache
      if (event.persisted && window.WishlistManager) {
        // Update all wishlist icons to reflect current state from localStorage
        window.WishlistManager.updateWishlistIcons();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
